export default __webpack_public_path__ + "static/custom_web-c0c95a10997708d28b5130bb1b0ef7c4.webp";